import {
  Header,
  SpaceBetween,
  HeaderProps,
} from "@cloudscape-design/components-themed";

interface FullPageHeaderProps extends HeaderProps {
  title: string;
  counter: string;
}

const TableEditHeader = ({ title, counter, actions }: FullPageHeaderProps) => {
  return (
    <SpaceBetween size="m">
      <Header variant="h1" actions={actions}>
        {title}
        {counter}
      </Header>
    </SpaceBetween>
  );
};

export default TableEditHeader;
